import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import ReviewsSection from "../../components/ReviewsSection";
import "../../styles/reviews.css";
import * as reviewApi from "../../services/reviews";

function ReviewPage() {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const history = useHistory();

  useEffect(() => {
    fetchReviews();
  }, []);

  const fetchReviews = async () => {
    setLoading(true);
    try {
      const res = await reviewApi.getReviews();
      setReviews(res.data);
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = () => {
    history.push("/reviews/new");
  };
  const handleEdit = (idx) => {
    const review = reviews[idx];
    if (review) history.push(`/reviews/${review.id}`);
  };
  const handleDelete = async (idx) => {
    const review = reviews[idx];
    if (!review) return;
    if (window.confirm("Are you sure you want to delete this review?")) {
      await reviewApi.deleteReview(review.id);
      fetchReviews();
    }
  };

  return (
    <div className="wrapper">
      <div className="container-fluid" style={{ padding: 0 }}>
        {loading ? (
          <div>Loading...</div>
        ) : (
          <ReviewsSection reviews={reviews} onAdd={handleAdd} onEdit={handleEdit} onDelete={handleDelete} />
        )}
      </div>
    </div>
  );
}

export default ReviewPage;
